(()=>{
  const FREE_SHIPPING=7500;
  const MAX_RECS=5;
  const MAIN_CART_SETTLE_MS=520;
  const RAIL_GAP_MS=2700;
  const RAIL_POST_INSERT_MIN_MS=120;
  const MAP={
    'stainless-steel-cleaner':['multi-surface-cleaner','glass-cleaner','granite-cleaner','hot-tub-and-spa-cleaner'],
    'granite-cleaner':['multi-surface-cleaner','glass-cleaner','stainless-steel-cleaner','hot-tub-and-spa-cleaner'],
    'multi-surface-cleaner':['glass-cleaner','granite-cleaner','stainless-steel-cleaner','hot-tub-and-spa-cleaner'],
    'glass-cleaner':['multi-surface-cleaner','granite-cleaner','stainless-steel-cleaner','hot-tub-and-spa-cleaner'],
    'hot-tub-and-spa-cleaner':['multi-surface-cleaner','glass-cleaner','granite-cleaner','stainless-steel-cleaner'],
    'lavender-french-juniper-aromatherapy-scented-candle':['lavender-french-juniper-reed-diffuser','lavender-french-juniper-linen-room-mist','calm-ritual-bundle'],
    'lavender-french-juniper-reed-diffuser':['lavender-french-juniper-linen-room-mist','lavender-french-juniper-aromatherapy-scented-candle','calm-ritual-bundle'],
    'lavender-french-juniper-linen-room-mist':['lavender-french-juniper-reed-diffuser','lavender-french-juniper-aromatherapy-scented-candle','calm-ritual-bundle']
  };

  const CACHE=new Map();
  const root=()=>window.Shopify?.routes?.root||'/';
  const money=c=>{
    try{
      return new Intl.NumberFormat(document.documentElement.lang||'en-US',{
        style:'currency',
        currency:window.Shopify?.currency?.active||'USD',
        minimumFractionDigits:c%100?2:0,
        maximumFractionDigits:2
      }).format(c/100)
    }catch(e){
      return'$'+(c/100).toFixed(2)
    }
  };
  const getCart=()=>fetch(root()+'cart.js',{headers:{Accept:'application/json'}}).then(r=>r.json());
  const getProduct=h=>{
    if(!CACHE.has(h)){
      CACHE.set(h,fetch(root()+'products/'+h+'.js',{headers:{Accept:'application/json'}})
        .then(r=>r.ok?r.json():null)
        .catch(()=>null))
    }
    return CACHE.get(h)
  };

  const candidateHandles=c=>{
    const inCart=new Set(c.items.map(i=>i.handle));
    const q=[];
    c.items.forEach(i=>(MAP[i.handle]||[]).forEach(h=>{
      if(!inCart.has(h)&&!q.includes(h))q.push(h)
    }));
    return q
  };

  const recommendations=async c=>{
    const result=[];
    for(const h of candidateHandles(c)){
      const p=await getProduct(h);
      const v=p?.variants?.find(x=>x.available);
      if(p&&v){
        result.push({p,v});
        if(result.length>=MAX_RECS)break
      }
    }
    return result
  };

  const shipping=c=>{
    const left=Math.max(FREE_SHIPPING-c.total_price,0);
    const pct=Math.min(c.total_price/FREE_SHIPPING*100,100);
    const d=document.createElement('div');
    d.className='hn-cart-aov-shipping';
    d.dataset.hnCartAov='shipping';
    d.innerHTML=`<p class="hn-cart-aov-shipping__copy">${
      left?`You’re <strong>${money(left)}</strong> away from free shipping`:'Free shipping unlocked'
    }</p><div class="hn-cart-aov-shipping__track" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="${Math.round(pct)}"><span class="hn-cart-aov-shipping__fill" style="--hn-cart-progress:${pct}%"></span></div>`;
    return d
  };

  const card=({p,v},mode='desktop')=>{
    const d=document.createElement('article');
    d.className='hn-cart-aov-card';
    const url=p.url||'/products/'+p.handle;
    const img=p.featured_image?`<a class="hn-cart-aov-card__image" href="${url}" tabindex="-1"><img src="${p.featured_image}" alt="" loading="lazy"></a>`:'';
    const addLabel=mode==='desktop'?'+':'Add';
    d.innerHTML=`${img}<a class="hn-cart-aov-card__title" href="${url}">${p.title}</a><p class="hn-cart-aov-card__price">${money(v.price)}</p><button class="hn-cart-aov-card__add" type="button" data-hn-cart-add data-variant-id="${v.id}" aria-label="Add ${p.title} to cart">${addLabel}</button><p class="hn-cart-aov-card__status" data-hn-cart-add-status></p>`;
    return d
  };

  const rail=recs=>{
    const a=document.createElement('aside');
    a.className='hn-cart-aov-rail';
    a.dataset.hnCartAov='rail';
    a.setAttribute('aria-label','Recommended products');
    a.innerHTML='<div class="hn-cart-aov-rail__header"><p class="hn-cart-aov-rail__eyebrow">Considered additions</p><h2 class="hn-cart-aov-rail__title">You may also like</h2></div><div class="hn-cart-aov-rail__list"></div>';
    const list=a.querySelector('.hn-cart-aov-rail__list');
    recs.forEach(r=>list.appendChild(card(r,'desktop')));
    return a
  };

  const mobile=recs=>{
    const s=document.createElement('section');
    s.className='hn-cart-aov-mobile';
    s.dataset.hnCartAov='mobile';
    s.innerHTML='<div class="hn-cart-aov-mobile__header"><p class="hn-cart-aov-mobile__eyebrow">Considered additions</p><h3 class="hn-cart-aov-mobile__title">Complete your home care</h3></div><div class="hn-cart-aov-mobile__scroller"></div>';
    const scroller=s.querySelector('.hn-cart-aov-mobile__scroller');
    recs.slice(0,4).forEach(r=>scroller.appendChild(card(r,'mobile')));
    return s
  };

  const resetRail=drawer=>{
    drawer.querySelector('.hn-cart-aov-rail')?.classList.remove('is-revealed')
  };

  const revealRail=(drawer,el)=>{
    if(!el||window.matchMedia('(max-width:989px)').matches)return;

    const notBefore=drawer._hnAovRailRevealNotBefore||performance.now();

    requestAnimationFrame(()=>{
      requestAnimationFrame(()=>{
        if(!el.isConnected)return;

        const wait=Math.max(
          RAIL_POST_INSERT_MIN_MS,
          notBefore-performance.now()
        );

        setTimeout(()=>{
          if(el.isConnected&&drawer.classList.contains('active')){
            el.classList.add('is-revealed')
          }
        },wait)
      })
    })
  };

  const render=async drawer=>{
    if(!drawer||drawer.dataset.hnAovRendering)return;
    drawer.dataset.hnAovRendering='1';
    try{
      const c=await getCart();
      drawer.querySelectorAll('[data-hn-cart-aov]').forEach(n=>n.remove());
      if(!c.item_count)return;

      const inner=drawer.querySelector('.drawer__inner');
      const header=drawer.querySelector('.drawer__header');
      if(header)header.insertAdjacentElement('afterend',shipping(c));

      const recs=await recommendations(c);
      if(!recs.length)return;

      const cartShell=drawer.querySelector('#CartDrawer');
      if(cartShell){
        const desktopRail=rail(recs);
        cartShell.insertBefore(desktopRail,inner);
        revealRail(drawer,desktopRail)
      }

      const items=drawer.querySelector('cart-drawer-items');
      if(items)items.appendChild(mobile(recs));
    }finally{
      delete drawer.dataset.hnAovRendering
    }
  };

  const add=async(drawer,button)=>{
    const id=Number(button.dataset.variantId);
    const status=button.parentElement.querySelector('[data-hn-cart-add-status]');
    const original=button.textContent;
    button.disabled=true;
    button.textContent='…';
    if(status)status.textContent='';
    try{
      const res=await fetch((typeof routes!=='undefined'&&routes.cart_add_url)||root()+'cart/add.js',{
        method:'POST',
        headers:{'Content-Type':'application/json',Accept:'application/json'},
        body:JSON.stringify({
          items:[{id,quantity:1}],
          sections:['cart-drawer','cart-icon-bubble'],
          sections_url:location.pathname
        })
      });
      const json=await res.json();
      if(!res.ok||json.status)throw new Error(json.description||'Unable to add this item.');
      if(drawer.renderContents)drawer.renderContents(json);
      setTimeout(()=>render(drawer),120);
    }catch(e){
      if(status)status.textContent=e.message;
      button.disabled=false;
      button.textContent=original
    }
  };

  const init=()=>{
    const drawer=document.querySelector('cart-drawer');
    if(!drawer||drawer.dataset.hnAovInitialized)return;
    drawer.dataset.hnAovInitialized='1';

    drawer.addEventListener('click',e=>{
      const b=e.target.closest('[data-hn-cart-add]');
      if(b){
        e.preventDefault();
        add(drawer,b)
      }
    });

    const open=drawer.open?.bind(drawer);
    if(open)drawer.open=(...args)=>{
      resetRail(drawer);
      drawer._hnAovRailRevealNotBefore=performance.now()+MAIN_CART_SETTLE_MS+RAIL_GAP_MS;
      const result=open(...args);
      setTimeout(()=>render(drawer),0);
      return result
    };

    const renderContents=drawer.renderContents?.bind(drawer);
    if(renderContents)drawer.renderContents=(...args)=>{
      const result=renderContents(...args);
      setTimeout(()=>render(drawer),80);
      return result
    };

    if(typeof subscribe==='function'&&typeof PUB_SUB_EVENTS!=='undefined'&&PUB_SUB_EVENTS.cartUpdate){
      subscribe(PUB_SUB_EVENTS.cartUpdate,()=>setTimeout(()=>render(drawer),80))
    }

    render(drawer)
  };

  const start=()=>customElements.whenDefined('cart-drawer').then(init);
  document.readyState==='loading'
    ?document.addEventListener('DOMContentLoaded',start,{once:true})
    :start()
})();
